export default {
	gutterBottom: {
		marginBottom: 16,
	},
};
